import {
  GETTING_QUERY_TEMPLATES_FAILED,
  GETTING_QUERY_TEMPLATE_FAILED,
  CREATING_QUERY_TEMPLATE_FAILED,
  UPDATING_QUERY_TEMPLATE_FAILED,
  DELETING_QUERY_TEMPLATES_FAILED,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED
} from 'store/recipientQueryTemplate/actions';

import { goToButton, dismissButton } from '../../helpers/error/buttonBuilders';
import { RECIPIENTQUERY, RECIPIENTQUERIES } from '../UserMessaging/userMessageDomains';

const recipientQueries = {
  [RECIPIENTQUERIES]: {
    [GETTING_QUERY_TEMPLATES_FAILED]: {
      userMessage: {
        instructions: 'Failed getting all templates',
        buttons: [dismissButton()]
      }
    },

    [GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED]: {
      userMessage: {
        instructions: 'Failed to archive template',
        buttons: [dismissButton()]
      }
    }
  }
};

const recipientQuery = {
  [RECIPIENTQUERY]: {
    [GETTING_QUERY_TEMPLATE_FAILED]: {
      resource: 'recipient-queries',
      userMessage: {
        buttons: [goToButton('OK', '/recipient-queries')]
      }
    },

    [GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED]: {
      resource: 'recipient-queries',
      userMessage: {
        instructions: 'Failed to archive template',
        buttons: [dismissButton()]
      }
    },

    [UPDATING_QUERY_TEMPLATE_FAILED]: {
      resource: 'recipient-queries',
      userMessage: {
        instructions: 'Could not save template, please try again',
        buttons: [dismissButton()]
      }
    },

    [DELETING_QUERY_TEMPLATES_FAILED]: {
      resource: 'recipient-queries',
      userMessage: {
        instructions: 'Could not delete template, please try again',
        buttons: [dismissButton()]
      }
    },

    [CREATING_QUERY_TEMPLATE_FAILED]: {
      resource: 'template',
      userMessage: {
        instructions: 'Could not save template, please try again',
        buttons: [dismissButton()]
      }
    }
  }
};

export default { ...recipientQueries, ...recipientQuery };
